// extracted by mini-css-extract-plugin
export default {"link":"TextLink_link__24z6j"};